export const translations = {
    en: {
      appName: 'Krishi Raksha',
      nav: {
        home: 'Home',
        features: 'Features',
        about: 'About',
        contact: 'Contact'
      },
      hero: {
        welcome: 'Welcome to Krishi Raksha',
        description: 'Your reliable solution for identifying and managing plant diseases effectively. Empowering farmers with cutting-edge technology to improve crop health.',
        startButton: 'Start Diagnosing'
      },
      features: {
        title: 'Why Choose Krishi Raksha?',
        aiDetection: 'AI-Powered Detection',
        aiDesc: 'Advanced algorithms for accurate disease identification',
        instantResults: 'Instant Results',
        instantDesc: 'Get immediate analysis and treatment recommendations',
        quickDetection: 'Quick Detection',
        quickDesc: 'Instant analysis of plant diseases using advanced AI',
        expertAdvice: 'Expert Advice',
        expertDesc: 'Detailed treatment recommendations from agricultural experts',
        easyUse: 'Easy to Use',
        easyDesc: 'Simple interface designed for farmers and agriculturists',
        reliable: 'Reliable Results',
        reliableDesc: 'High accuracy in disease detection and analysis'
      },
      about: {
        title: 'About Krishi Raksha',
        description: 'Krishi Raksha is an AI-powered platform designed to help farmers identify plant diseases and recommend actionable solutions. With state-of-the-art AI and real-time analysis, we aim to make agriculture smarter, more sustainable, and efficient.'
      },
      contact: {
        title: 'Contact Us',
        content: 'We\'d love to hear from you! Whether you have a question about features, trials, pricing, or anything else, our team is ready to answer all your questions.',
        form: {
          namePlaceholder: 'Your Name',
          emailPlaceholder: 'Your Email',
          messagePlaceholder: 'Your Message',
          sendButton: 'Send Message'
        }
      },
      footer: {
        tagline: 'Empowering Agriculture with AI',
        contact: 'Contact Us',
        email: 'Email: info@krishiraksha.com',
        phone: 'Phone: +91 XXXXXXXXXX',
        rights: '© 2024 Krishi Raksha | All Rights Reserved'
      },
      diagnosis: {
        backButton: 'Back to Home'
      }
    },
    hi: {
      appName: 'कृषि रक्षा',
      nav: {
        home: 'होम',
        features: 'विशेषताएं',
        about: 'हमारे बारे में',
        contact: 'संपर्क करें'
      },
      hero: {
        welcome: 'कृषि रक्षा में आपका स्वागत है',
        description: 'पौधों की बीमारियों की पहचान और प्रबंधन के लिए आपका विश्वसनीय समाधान। फसल स्वास्थ्य में सुधार के लिए किसानों को उन्नत तकनीक से सशक्त बनाना।',
        startButton: 'निदान शुरू करें'
      },
      features: {
        title: 'कृषि रक्षा क्यों चुनें?',
        aiDetection: 'एआई-संचालित पहचान',
        aiDesc: 'सटीक रोग पहचान के लिए उन्नत एल्गोरिदम',
        instantResults: 'तत्काल परिणाम',
        instantDesc: 'तत्काल विश्लेषण और उपचार सिफारिशें प्राप्त करें',
        quickDetection: 'त्वरित पहचान',
        quickDesc: 'उन्नत एआई का उपयोग करके पौधों की बीमारियों का त्वरित विश्लेषण',
        expertAdvice: 'विशेषज्ञ सलाह',
        expertDesc: 'कृषि विशेषज्ञों से विस्तृत उपचार सिफारिशें',
        easyUse: 'उपयोग में आसान',
        easyDesc: 'किसानों और कृषि विशेषज्ञों के लिए डिज़ाइन किया गया सरल इंटरफ़ेस',
        reliable: 'विश्वसनीय परिणाम',
        reliableDesc: 'रोग पहचान और विश्लेषण में उच्च सटीकता'
      },
      about: {
        title: 'कृषि रक्षा के बारे में',
        description: 'कृषि रक्षा एक एआई-संचालित प्लेटफ़ॉर्म है जो किसानों को पौधों की बीमारियों की पहचान करने और क्रियाशील समाधान सुझाने में मदद करता है। अत्याधुनिक एआई और रियल-टाइम विश्लेषण के साथ, हम कृषि को अधिक स्मार्ट, टिकाऊ और कुशल बनाने का लक्ष्य रखते हैं।'
      },
      contact: {
        title: 'संपर्क करें',
        content: 'हम आपसे सुनना पसंद करेंगे! चाहे आपके पास विशेषताओं, परीक्षणों, मूल्य निर्धारण, या किसी अन्य चीज़ के बारे में कोई प्रश्न हो, हमारी टीम आपके सभी प्रश्नों का उत्तर देने के लिए तैयार है।',
        form: {
          namePlaceholder: 'आपका नाम',
          emailPlaceholder: 'आपका ईमेल',
          messagePlaceholder: 'आपका संदेश',
          sendButton: 'संदेश भेजें'
        }
      },
      footer: {
        tagline: 'एआई के साथ कृषि को सशक्त बनाना',
        contact: 'संपर्क करें',
        email: 'ईमेल: info@krishiraksha.com',
        phone: 'फोन: +91 XXXXXXXXXX',
        rights: '© 2024 कृषि रक्षा | सर्वाधिकार सुरक्षित'
      },
      diagnosis: {
        backButton: 'होम पर वापस जाएं'
      }
    }
  };
  